import { Link } from "@chakra-ui/react";
import { InvestmentPaymentMethodType } from "@verivest/shared-components/src/api/enums";
import { InvestmentModel } from "@verivest/shared-components/src/api/models";
import { VeriModal } from "@verivest/shared-components/src/components/modals/VeriModal";
import React, { ReactNode, useState } from "react";
import { choosePaymentInstructions } from "./choosePaymentInstructions";
import {
  PaymentInstructions,
  PaymentInstructionsData,
} from "./PaymentInstructions";

interface FundingInstructionsModalProps extends PaymentInstructionsData {
  onClose: () => void;
  isOpen: boolean;
  paymentMethod: string | null | undefined;
}

const FundingInstructionsModal = ({
  onClose,
  isOpen,
  paymentMethod,
  instructionsText,
  instructionsUrl,
}: FundingInstructionsModalProps) => {
  return (
    <VeriModal isCentered isOpen={isOpen} onClose={onClose}>
      {paymentMethod ? (
        <PaymentInstructions
          method={paymentMethod}
          instructionsText={instructionsText}
          instructionsUrl={instructionsUrl}
        />
      ) : null}
    </VeriModal>
  );
};

export const FundingInstructionsLink = ({
  investment,
  linkContent = "View instructions",
  paymentMethod,
}: {
  investment: InvestmentModel;
  linkContent?: ReactNode;
  paymentMethod: InvestmentPaymentMethodType | null | undefined;
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const opportunity = investment.offering?.opportunity || {};
  const {
    checkInstructions,
    checkInstructionsUrl,
    wireInstructions,
    wireInstructionsUrl,
  } = opportunity;

  const { instructionsText, instructionsUrl } = choosePaymentInstructions({
    paymentMethod,
    checkInstructions,
    checkInstructionsUrl,
    wireInstructions,
    wireInstructionsUrl,
  });

  if (!instructionsText && !instructionsUrl) {
    return null;
  }

  return (
    <>
      <Link onClick={() => setModalOpen(true)} color="brand.main">
        {linkContent}
      </Link>
      <FundingInstructionsModal
        instructionsText={instructionsText}
        instructionsUrl={instructionsUrl}
        paymentMethod={paymentMethod}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};
